import React, {useState} from 'react';
import PropTypes from 'prop-types';
import {generalUiTexts} from 'data/ui-texts';
import Missions from 'components/missions/missions';
import SurveysPrint from 'components/surveys-print/surveys-print';
import Info from 'components/ui/info/info';
import './main-menu.scss';

const MainMenu = (props) => {
	let {
		animateSlideIn,
		isPlaying, 
		isGameover,
		playerData,
		decksData,
		missionsData,
		handleShowPage, 
		handleContinueGame
	} = props;

	const [showMissions, setShowMissions] = useState(false);
	const [showSurveys, setShowSurveys] = useState(false);
	const [showInfo, setShowInfo] = useState(false);
	
	let playBtnText = generalUiTexts.startGame;
	if (isPlaying || (playerData.introSeen && !playerData.gameEnded)) playBtnText = generalUiTexts.continueGame;
	if ((!isPlaying || (isPlaying && isGameover)) && playerData.gameEnded) playBtnText = generalUiTexts.continuePlaying;
	
	/**
	 * Start / continue game
	 */
	const handlePlay = () => {
		if (!isPlaying && !playerData.introSeen) {
			/* First time playing, start with intro */
			handleShowPage('intro');
		} else {
			if (!isPlaying) {
				/* Start game */
				handleShowPage('mazeGame');
			} else {
				/* Continue game */
				handleContinueGame();
			}
		}
	};

	
	return (
		<div className={'MainMenu' + (animateSlideIn ? ' slideIn' : '') + (isPlaying ? ' popup' : '')}>
			<div className="MainMenu-content">
				<div className="MainMenu-title" />
				<div className="MainMenu-playBtn" onClick={() => {handlePlay();}}>
					<span>{playBtnText}</span>
				</div>
				<div className="MainMenu-missionsBtn" onClick={() => {setShowMissions(true);}}>
					<span>{generalUiTexts.viewMissions}</span>
				</div>
				<div className="MainMenu-surveysBtn" onClick={() => {setShowSurveys(true);}}>
					<span>{generalUiTexts.viewSurveys}</span>
				</div>
				<div className="MainMenu-infoBtn" onClick={() => {setShowInfo(true);}} />
			</div>

			{/* Missions popup */}
			{showMissions && 
				<Missions 
					playerData={playerData}
					decksData={decksData}
					missionsData={missionsData}
					closePopup={() => {setShowMissions(false);}}
				/>
			}

			{/* Surveys popup */}
			{showSurveys && 
				<SurveysPrint 
					closePopup={() => {setShowSurveys(false);}} 
				/>
			}

			{/* Info popup */}
			{showInfo && <Info closePopup={() => {setShowInfo(false);}} />}
		</div>				
	);
};

MainMenu.propTypes = {
	animateSlideIn: PropTypes.bool.isRequired,
	isPlaying: PropTypes.bool.isRequired,
	isGameover: PropTypes.bool.isRequired,
	playerData: PropTypes.object.isRequired,
	decksData: PropTypes.array.isRequired,
	missionsData: PropTypes.array.isRequired,
	handleShowPage: PropTypes.func,
	handleContinueGame: PropTypes.func
};

export default MainMenu;